

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL= createAsyncThunk(
  "bulkUpdateActiveDeactiveEmployeeFromExcel/bulkUpdateActiveDeactiveEmployeeFromExcel",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const bulkUpdateActiveDeactiveEmployeeFromExcelSlice = createSlice({
  name: "bulkUpdateActiveDeactiveEmployeeFromExcelSlice",
  initialState: {
    bulkUpdateActiveDeactiveEmployeeFromExcel: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfbulkUpdateActiveDeactiveEmployeeFromExcel: (state) => {
        state.bulkUpdateActiveDeactiveEmployeeFromExcel.loading = false
        state.bulkUpdateActiveDeactiveEmployeeFromExcel.error = false
        state.bulkUpdateActiveDeactiveEmployeeFromExcel.data = []
        state.bulkUpdateActiveDeactiveEmployeeFromExcel.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL.fulfilled, (state, action) => {
      state.bulkUpdateActiveDeactiveEmployeeFromExcel = {
        ...state.bulkUpdateActiveDeactiveEmployeeFromExcel,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL.pending, (state, action) => {
      state.bulkUpdateActiveDeactiveEmployeeFromExcel = {
        ...state.bulkUpdateActiveDeactiveEmployeeFromExcel,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL.rejected, (state, action) => {
      state.bulkUpdateActiveDeactiveEmployeeFromExcel = {
        ...state.bulkUpdateActiveDeactiveEmployeeFromExcel,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const bulkUpdateActiveDeactiveEmployeeFromExcelAction = {
    BULKUPDATEACTIVATEDEACTIVATEDEMPLOYEEFROMEXCEL,
};

export { bulkUpdateActiveDeactiveEmployeeFromExcelAction };
export default bulkUpdateActiveDeactiveEmployeeFromExcelSlice.reducer;
export const {setInitialStateOfbulkUpdateActiveDeactiveEmployeeFromExcel} = bulkUpdateActiveDeactiveEmployeeFromExcelSlice.actions
